module.exports = __webpack_public_path__ + "static/RevDev-a5bd2a12a388d73761d359b618c965a3.png";